import { Box } from '@mui/material';
import { InstantSearch } from 'react-instantsearch';
import { useAtomValue } from 'jotai';
import { useSearchClient } from '../../hooks/useSearchClient';
import SearchConfigure from '../../search/SearchConfigure';
import SearchPagination from '../../search/SearchPagination';
import FilterUtils from '../../search/filters/filter.utils';
import useUpdateHistoryUiState from '../hooks/useUpdateHistoryUiState';
import { currentContextAtom } from '../../state';
import DiscoveryNavigationWrapper from '../navigation/DiscoveryNavigationWrapper';
import useDiscoveryDefaultFilters from '../../hooks/useDiscoveryDefaultFilters';
import { DISCOVERY_AS_BUYER_HITS_PER_PAGE } from './DiscoveryAsBuyerPage';
import DiscoveryProductHits from './DiscoveryProductHits';

export default function ProductsDiscovery(): React.JSX.Element {
  const searchClient = useSearchClient();
  const index = import.meta.env.REACT_APP_ALGOLIA_PACKAGING_INDEX;
  const { initialIndexUiState, updateUiState } = useUpdateHistoryUiState({ index });
  const { companyId } = useAtomValue(currentContextAtom);
  const defaultFilters = useDiscoveryDefaultFilters('PRODUCT');
  const filters = `${defaultFilters} AND ${FilterUtils.GetSignedContractFilter('buyers', companyId)}`;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <InstantSearch
        indexName={index}
        searchClient={searchClient}
        initialUiState={{
          [index]: initialIndexUiState,
        }}
        onStateChange={updateUiState}
      >
        <SearchConfigure index={index} filters={filters} hitsPerPage={DISCOVERY_AS_BUYER_HITS_PER_PAGE}>
          <DiscoveryNavigationWrapper attribute="family">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                pb: 3,
                mx: {
                  xs: -1,
                  sm: 0,
                },
              }}
            >
              <DiscoveryProductHits />
              <SearchPagination />
            </Box>
          </DiscoveryNavigationWrapper>
        </SearchConfigure>
      </InstantSearch>
    </Box>
  );
}
